var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"tile"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('div',[_c('div',{staticClass:"tile-img",style:({'background-image': `url(${_vm.img})`})}),_c('p',{staticClass:"tile-title"},[_vm._v(_vm._s(_vm.title))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }